import { render, staticRenderFns } from "./contact-person-search.vue?vue&type=template&id=abce0e4a&lang=pug"
import script from "./contact-person-search.vue?vue&type=script&lang=ts"
export * from "./contact-person-search.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports